import axios from 'axios';

import apiPaths from 'enums/apiPaths';

export const loginCertApiNew = () => {
    return axios({
        method: 'GET',
        url: apiPaths.LOGIN_CERT
    });
};
